import { getStore } from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('removeMailItemWithData')(function (data) {
    var delayStore = getStore();
    for (var i = 0; i < delayStore.delayedMailItems.length; i++) {
        if (delayStore.delayedMailItems[i].data == data) {
            delayStore.delayedMailItems.splice(i, 1);
            break;
        }
    }
});
//# sourceMappingURL=removeMailItemWithData.js.map